export default __webpack_public_path__ + "static/media/package2.52cc8c2e.jpg";